import React from 'react';
import { makeStyles } from '@material-ui/core';
import { productionOrderStates as state } from '../../../Config/productionOrderStates'
import PlayArrowRoundedIcon from '@material-ui/icons/PlayArrowRounded';
import PauseRoundedIcon from '@material-ui/icons/PauseRounded';
import Timer from '../../Shared/Timer';
import { fromNewDateFormatToDDMMYYYYHHmmssSlash } from '../../../Helpers/dateHelper';

export default function ProductionOrderOrderContent(props) {
    const classes = useStyles();

    let stateIcon = <React.Fragment></React.Fragment>;
    if(props.order){
        switch (props.order.productionOrderStatus) {
            case state.RUNNING:
                stateIcon = <PlayArrowRoundedIcon className={classes.play}></PlayArrowRoundedIcon>;
                break;
            case state.PAUSED:
                stateIcon = <PauseRoundedIcon className={classes.pause} ></PauseRoundedIcon>;
                break;
            case state.STOPPED:
                stateIcon = <div className={classes.stop}></div>;
                break;
            case state.DONE:
                stateIcon = <img className={classes.done} alt="done" src={process.env.PUBLIC_URL + '/img/done.svg'}></img>
                break;
            case state.PLANNED:
                stateIcon = <img className={classes.planned} alt="planned" src={process.env.PUBLIC_URL + '/img/planned.svg'}></img>
                break;
            default:
        }
    }  

    return (
        <React.Fragment>
            <div className={classes.label}>
                {props.current ? "Current production order" : "Next production order"}
            </div>
            {props.order ? <React.Fragment>
                <div className={classes.orderReference}>
                    {props.order.reference}
                </div>
                <div className={classes.stateContainer}>
                    <div className={classes.icon}>{stateIcon}</div>
                    <div className={classes.stateElapsed}>
                        <div className={classes.state} style={{paddingTop:props.current? "Opx":"2px"}}>{(props.order.productionOrderStatus)}</div>
                        {props.current && <div className={classes.elapsed}><Timer startTime={props.order.startedOn} {...props}></Timer></div>}
                    </div>
                </div>
                <div className={classes.startStop}>
                    <div className={classes.start}>
                        <div className={classes.label2}>
                        {props.current ? "Start:":"Planned start:"}
                        </div>
                        <div className={classes.startText}>
                            {String(fromNewDateFormatToDDMMYYYYHHmmssSlash(new Date(props.current? props.order.startedOn:props.order.startedOnPlanned)))}
                        </div>
                    </div>
                    <div className={classes.stop}>
                        <div className={classes.label2}>
                            Planned stop:
                        </div>
                        <div className={classes.stopText}>
                            {String(fromNewDateFormatToDDMMYYYYHHmmssSlash(new Date(props.order.finishedOnPlanned)))}
                        </div>
                    </div>
                </div>


            </React.Fragment>
                :
                <div className={classes.orderReference}>
                    There are currently no active orders
                </div>}
        </React.Fragment>
    )

}

const useStyles = makeStyles(() => ({
    label: {
        fontSize: "15px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'Medium',
        color: '#8D8D8D',
        marginBottom: "5px"
    },
    label2: {
        fontSize: "12px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'Medium',
        color: '#8D8D8D',
        marginBottom: "5px",
        float: "left",
        marginRight: "5px"
    },
    orderReference: {
        fontSize: "28px",
        fontFamily: "Lato, sans-serif",
        display: "inline-block",
        marginLeft: "10px",
        paddingTop: "5px"
        // fontWeight: 'bold',
    },
    stateContainer: {
        display: "inline-block",
        paddingTop: "5px",
        float: "left"

    },
    icon: {
        float: "left"
    },
    state: {
        textTransform: "uppercase",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'bold',
        color: "#020100",
        display: "block"
    },
    stateElapsed: {
        float: "left",
        marginLeft: "5px",
        marginTop: "5px"
    },
    elapsed: {
        fontSize: "10px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        color: "#8D8D8D",
        display: "block"
    },
    pause: {
        height: "35px",
        width: "35px",
        color: "#F59127",
    },
    play: {
        color: "#5CC958",
        height: "40px",
        width: "40px"
    },
    startText: {
        fontSize: "12px",
        fontFamily: "Lato, sans-serif",
        float: "left"
    },
    stopText: {
        fontSize: "12px",
        fontFamily: "Lato, sans-serif",
        float: "left"
    },
    start: {
        height: "20px",
        display: "inline-block"
    },
    stop: {
        height: "20px",
        display: "inline-block",
        float: "right"

    },
    startStop: {
        marginTop: "15px"
    },
    planned:{
        paddingTop:"4px",
        marginRight:"5px",
        marginLeft:"5px"
    }


}));